// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`SectionLabel test Match con el snapshot 1`] = `
<div class="label">
    <p style="color: rgb(18, 18, 18);"></p>
</div>
`;
